import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import { ButtonLinkTypeEnum } from 'common/enums/ButtonLinkEnum'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { BlogLinkActionButtonEntityInterface } from 'src/shared/entities/button/blog-link.action-button.schema'
import { ButtonEntityInterface } from 'src/shared/entities/button/button.schema'
import { createButtonNew } from 'src/shared/entities/button/create-button'
import { DownloadFileActionButtonEntityInterface } from 'src/shared/entities/button/download-file.action-button.schema'
import {
  SendFormActionButtonCustomUrlEntityInterface,
  SendFormActionButtonEntityInterface,
} from 'src/shared/entities/button/send-form.action-button.schema'
import { ShowPopupActionButtonEntityInterface } from 'src/shared/entities/button/show-popup.action-button.schema'
import {
  LinkTargetEntityInterface,
  LinkUrlEntityInterface,
  RelEntityInterface,
} from 'src/shared/schemas/buttons/buttons-entities-properties.schema'
import {
  migrateButtonFontSize,
  migrateButtonIcons,
  migrateButtonText,
  migrateButtonTextColor,
  migrateButtonWidth,
} from 'tools/commands/migrate/UpsellButton/migrateButtonUtils'
import {
  migrateAlignSelf,
  migrateBoxShadow,
  migrateFullBorderType,
  migrateLineHeight,
  migrateMargin,
  migrateMobileMargin,
  migratePadding,
  migrateReadOnly,
} from 'tools/commands/migrate/utils/migrateUtils'

const isActionButton = (
  button: ButtonEntityInterface,
): button is ActionButtonEntityInterface => {
  return [
    ButtonActionTypeEnum.NextStepRedirection,
    ButtonActionTypeEnum.OpenUrl,
    ButtonActionTypeEnum.DownloadFile,
    ButtonActionTypeEnum.SendForm,
    ButtonActionTypeEnum.ShowPopup,
    ButtonActionTypeEnum.BlogLink,
  ].includes(button.action as ButtonActionTypeEnum)
}

export const migrateButton = (entity: OldEntityInterface) => {
  const button = createButtonNew(
    entity.parentId,
    entity.options.text,
    entity.options.subText,
    entity.masterBlockId,
  )

  button.id = entity.id
  button.htmlAttrId = entity.options.attrId

  if (
    entity.options.appearance &&
    !(entity.options.appearance.desktop && entity.options.appearance.mobile)
  ) {
    button.appearance = entity.options.appearance
  }

  migrateMargin(button, entity)
  migrateMobileMargin(button, entity)
  migrateLineHeight(button, entity)
  migrateFullBorderType(button, entity)
  migrateAlignSelf(button, entity)
  migrateBoxShadow(button, entity)
  migrateButtonIcons(button, entity)
  migrateButtonText(button, entity)
  migrateButtonTextColor(button, entity)
  migrateButtonWidth(button, entity)
  migrateButtonFontSize(button, entity)

  if (entity.styles.padding) {
    button.padding = migratePadding(entity.styles.padding)
  }

  if (entity.mobileStyles.padding) {
    button.mobilePadding = migratePadding(entity.mobileStyles.padding)
  }

  //color
  if (entity.styles.textColor) {
    button.textColor = entity.styles.color
  }

  if (entity.mobileStyles && entity.mobileStyles.textColor) {
    button.mobileTextColor = entity.mobileStyles.textColor
  }

  if (entity.options.action) {
    button.action = entity.options.action
  }

  if (entity.options.delay) {
    button.delay = entity.options.delay
  }

  if (entity.styles.background || entity.styles.backgroundColor) {
    button.background =
      entity.styles.background || entity.styles.backgroundColor
  }

  if (entity.mobileStyles.background || entity.mobileStyles.backgroundColor) {
    button.mobileBackground =
      entity.mobileStyles.background || entity.mobileStyles.backgroundColor
  }

  if (isActionButton(button)) {
    if (entity.options.urlRedirect) {
      ;(button as SendFormActionButtonCustomUrlEntityInterface).urlRedirect =
        entity.options.urlRedirect
    }

    if (entity.options.blogLink) {
      ;(button as BlogLinkActionButtonEntityInterface).blogLink =
        entity.options.blogLink
    }

    if (entity.options.rel) {
      ;(button as RelEntityInterface).rel = entity.options.rel
    }

    if (entity.options.popup) {
      ;(button as ShowPopupActionButtonEntityInterface).popup =
        entity.options.popup
    }

    if (entity.options.linkTarget) {
      if (entity.options.linkTarget in ButtonLinkTypeEnum) {
        ;(button as LinkTargetEntityInterface).linkTarget =
          ButtonLinkTypeEnum[
            entity.options.linkTarget as keyof typeof ButtonLinkTypeEnum
          ]
      } else {
        ;(button as LinkTargetEntityInterface).linkTarget =
          entity.options.linkTarget
      }
    }

    if (entity.options.srcFileId) {
      ;(button as DownloadFileActionButtonEntityInterface).fileId =
        entity.options.srcFileId
    }

    if (entity.options.redirectionType) {
      ;(button as SendFormActionButtonEntityInterface).redirectionType =
        entity.options.redirectionType
    }

    if (entity.options.linkUrl) {
      ;(button as LinkUrlEntityInterface).linkUrl = entity.options.linkUrl
    }
  }

  if (entity.options.hover) {
    button.hover = entity.options.hover
  }

  if (entity.mobileOptions.hover) {
    button.mobileHover = entity.mobileOptions.hover
  }

  migrateReadOnly(button, entity)

  return button
}
